export default {
    BASE_URL: '/company/rms',
    api: [
        {
            name: 'list',
            desc: '招聘列表',
            method: 'GET',
            path: '/list'
        },
        {
            name: 'insert',
            desc: '发布招聘',
            method: 'POST',
            path: '/insert'
        },
        {
            name: 'update',
            desc: '编辑招聘记录',
            method: 'PUT',
            path: '/edit'
        },
        {
            name: 'close',
            desc: '关闭招聘记录',
            method: 'PUT',
            path: '/close'
        },
        {
            name: 'delete',
            desc: '删除招聘记录',
            method: 'DELETE',
            path: '/delete'
        },
        {
            name: 'refresh',
            desc: '重新发布',
            method: 'PUT',
            path: '/refresh'
        },
        {
            name: 'republish',
            desc: '再次发布，复制原招聘记录',
            method: 'GET',
            path: '/republish'
        },
        {
            name: 'publish',
            desc: '发布',
            method: 'PUT',
            path: '/publish'
        },
        {
            name: 'info',
            desc: '获取招聘信息',
            method: 'GET',
            path: 'detail'
        },
        {
            name: 'applyList',
            desc: '获取应聘列表',
            method: 'GET',
            path: '/apply/list'
        },
        {
            name: 'teamMemberList',
            desc: '获取班组成员',
            method: 'GET',
            path: '/apply/team/employees'
        },
        {
            name: 'disagreeApply',
            desc: '拒绝入场',
            method: 'PUT',
            path: '/apply/refuse'
        },
        {
            name: 'agreeApply',
            desc: '同意入场',
            method: 'POST',
            path: '/apply/invite'
        },
        {
            name: 'getLaborCompany',
            desc: '获取劳务承包公司',
            method: 'GET',
            path: '/laborCompany'
        }
    ]
}



// WEBPACK FOOTER //
// ./src/api/project/job/job-demand.js